module.exports = __webpack_public_path__ + "assets/img/hontoyutari.baea96d5.svg";